import { getCartTotal } from "../../../../../../Services/Ecommerce.service";
import {
  Price,
  ProductName,
  Quantity,
  Sub_total,
} from "../../../../../../Constant";
import { H6, P } from "../../../../../../AbstractElements";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceDescription from "./InvoiceDescription";
import PrintInvoice from "./PrintInvoice";
import { Col, Label, Row, Table, Container, CardBody, Card } from "reactstrap";
import React, { Component, Fragment } from "react";
import InvoiceDetails from "./InvoiceDetails";

class ItemDescription extends Component {
  render() {
    const { cart, symbol, rowData, data, view } = this.props;

    console.log(rowData);

    const payment = rowData.prescription.map((prep) => prep.already_paid)
    // const maen = rowData?`${rowData.morning === "yes" ? 1 : 0}-${
    //   rowData.afternoon === "yes" ? 1 : 0
    // }-${rowData.evening === "yes" ? 1 : 0}-${rowData.night === "yes" ? 1 : 0}`: ""

    // const intake = rowData?rowData.after_food === null ? `${rowData.before_food === "yes" ? "Before-food" : "-" }`: `${rowData.after_food === "yes" ? "After-food" : "-" }`: "";

    console.log(payment)
    const prescriptiontabledata = {
      prescriptionname: rowData.prescription
        .map((prep) => prep.sub_name)
        .join(","),
      quantity: rowData.prescription.map((prep) => prep.quantity).join(","),
      duration: rowData.prescription.map((prep) => prep.duration).join(","),
      maen: rowData.prescription
        .map(
          (prep) =>
            `${prep.morning === "yes" ? 1 : 0}-${
              prep.afternoon === "yes" ? 1 : 0
            }-${prep.evening === "yes" ? 1 : 0}-${prep.night === "yes" ? 1 : 0}`
        )
        .join(","),
      intake: rowData.prescription
        .map((prep) =>
          prep.after_food === null
            ? prep.before_food === "yes"
              ? "Before-food"
              : "-"
            : prep.after_food === "yes"
            ? "After-food"
            : "-"
        )
        .join(","),
    };

    return (
      <Fragment>
        <div className="p-3 m-0">
          <Container fluid>
            <Row>
              <Col sm="12">
                <Card>
                <CardBody>
                <div className="invoice">
                  <div>
                    <InvoiceHeader />
                    <InvoiceDescription />
                    <div className="table-responsive invoice-table" id="table">
                      <Table bordered striped>
                        <thead>
                          <tr>
                            <th className="item">Prescription Name</th>
                            <th className="Rate">M-A-E-N</th>
                            <th className="intake">In-Take</th>
                            <th className="quantity">Quantity</th>
                            <th className="duration">Duration</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rowData.prescription &&
                            rowData.prescription.map((prep, index) => (
                              <tr key={index}>
                                <td>
                                  <Label>{prep.sub_name}</Label>
                                </td>
                                <td>
                                  <P
                                    attrPara={{ className: "itemtext digits" }}
                                  >
                                    {`${prep.morning === "yes" ? 1 : 0}-${
                                      prep.afternoon === "yes" ? 1 : 0
                                    }-${prep.evening === "yes" ? 1 : 0}-${
                                      prep.night === "yes" ? 1 : 0
                                    }`}
                                  </P>
                                </td>
                                <td>
                                  <P
                                    attrPara={{ className: "itemtext digits" }}
                                  >
                                    {prep.after_food === null
                                      ? prep.before_food === "yes"
                                        ? "Before-food"
                                        : "-"
                                      : prep.after_food === "yes"
                                      ? "After-food"
                                      : "-"}
                                  </P>
                                </td>
                                <td className="payment digits">
                                  <P
                                    attrPara={{ className: "itemtext digits" }}
                                  >
                                    {prep.quantity}
                                  </P>
                                </td>
                                <td className="payment digits">
                                  <P
                                    attrPara={{ className: "itemtext digits" }}
                                  >
                                    {prep.duration}
                                  </P>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>

                      {/* <Table bordered striped>
                          <tbody>
                            <tr>
                              <td className='item'>
                                <H6 attrH6={{ className: 'p-2 mb-0' }}>{"Presciption Name"}</H6>
                              </td>
                              <td className='Rate'>
                                <H6 attrH6={{ className: 'p-2 mb-0' }}>{"M-A-E-N"}</H6>
                              </td>
                              <td className='intake'>
                                <H6 attrH6={{ className: 'p-2 mb-0' }}>{"In-Take"}</H6>
                              </td>
                              <td className='quantity'>
                                <H6 attrH6={{ className: 'p-2 mb-0' }}>{"Quantity"}</H6>
                              </td>
                              <td className='duration'>
                                <H6 attrH6={{ className: 'p-2 mb-0' }}>{"duration"}</H6>
                              </td>
                            </tr>
                            {rowData &&
                              
                              
                                  <tr >
                                    <td>
                                      <Label>{prescriptiontabledata.prescriptionname}</Label>
                                    </td>
                                    <td>
                                      <P attrPara={{ className: 'itemtext digits' }}>{prescriptiontabledata.maen}</P>
                                    </td>
                                    <td>
                                      <P attrPara={{ className: 'itemtext digits' }}>
                                       {prescriptiontabledata.intake}
                                      </P>
                                    </td>
                                    <td className='payment digits'>
                                      <P attrPara={{ className: 'itemtext digits' }}>
                                        {prescriptiontabledata.quantity}
                                      </P>
                                    </td>
                                    <td className='payment digits'>
                                      <P attrPara={{ className: 'itemtext digits' }}>
                                        {prescriptiontabledata.duration}
                                      </P>
                                    </td>
                                  </tr>
                                }
                              
                          </tbody>
                        </Table> */}
                    </div>
                    <div className="mb-5 mt-5">
                      {!view && <InvoiceDetails details ={rowData} />}
                    </div>
                    <PrintInvoice data={data} />
                  </div>
                </div>
                </CardBody>
              </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Fragment>
    );
  }
}

export default ItemDescription;
